import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/lib/ThemeContext";
import { useLenis } from "@/lib/useLenis";
import { Nav } from "@/components/portfolio/Nav";
import { Hero } from "@/components/portfolio/Hero";
import { TripleMarquee } from "@/components/portfolio/TripleMarquee";
import { Experience } from "@/components/portfolio/Experience";
import { Education } from "@/components/portfolio/Education";
import { Projects } from "@/components/portfolio/Projects";
import { Contact } from "@/components/portfolio/Contact";
import { Footer } from "@/components/portfolio/Footer";

const Portfolio = () => {
    useLenis();
    return (
        <div className="App relative">
            <Nav />
            <main data-testid="main">
                <Hero />
                <TripleMarquee />
                <Experience />
                <Education />
                <Projects />
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Portfolio />} />
                    <Route path="*" element={<Portfolio />} />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
